import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.user.search.estimatorSortFields,
	columnFields: constants.user.search.estimatorColumnFields,
	standardFilterFields: constants.user.search.estimatorFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
